import { ResourceType, ResourceTypes } from "../types/rolePermissions";

const prodDisabledResources: ResourceType[] = [ResourceTypes.ContactSearch];

const devDisabledResources: ResourceType[] = [];

export const disabledResources = process.env.REACT_APP_ENV === 'prod' ? prodDisabledResources : devDisabledResources;
